import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { BOOKING_LINK, services } from '../data/homepage';
export function WaysWeHelp() {
  return <section aria-labelledby="help-heading" className="on-light bg-paper pb-24 pt-12 md:pb-32" data-id="element-238" data-mp="3tfn673u2bjx2">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-239" data-mp="292h3pnkim2o">
        <Reveal className="max-w-3xl" data-id="element-240" data-mp="29m0zbws3kjc">
          <h2 id="help-heading" className="font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-241" data-mp="pyolqsmplti2">
            Ways we help
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-242" data-mp="ux87ot1az5af" />
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-3 md:gap-8" data-id="element-243" data-mp="g82833yjzd20">
          {services.map((service, i) => <li key={service.title} data-id="element-244" data-mp="l6dk9lcblzne" data-mpi={i}>
              <Reveal delay={i * 0.05} className="relative flex h-full flex-col rounded-sm border border-navy/10 bg-white p-8 md:p-10" data-id="element-245" data-mp="18xizpzecmpx6">
                {service.comingSoon && <span className="absolute right-6 top-6 rounded-sm bg-honor px-2.5 py-1 text-xs font-semibold uppercase tracking-wider text-paper" data-id="element-246" data-mp="3p3wcbmlqfxke">
                    Coming Soon
                  </span>}
                <h3 className="pr-24 font-serif text-2xl font-semibold leading-snug text-navy" data-id="element-247" data-mp="1seubqdgwd35">{service.title}</h3>
                <p className="mt-4 text-lg leading-relaxed text-charcoal" data-id="element-248" data-mp="3t4zpu2gb5hig">{service.body}</p>
                <div className="mt-auto pt-8" data-id="element-249" data-mp="bo84j33pruhr">
                  <div className="border-t border-navy/10 pt-6" data-id="element-250" data-mp="6qyg9qs29ovi">
                    <a href={BOOKING_LINK} className="inline-flex min-h-[48px] items-center gap-2 text-lg font-semibold text-navy transition-colors duration-150 ease-out hover:text-honor" data-id="element-251" data-mp="6sst0ht6iaoi">
                      Ask us on your free call
                      <ArrowRightIcon aria-hidden="true" className="h-5 w-5" data-id="element-252" data-mp="2mjx5opv2l2q4" />
                    </a>
                  </div>
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}